import { useShare } from '../hooks/useShare';
import ShareButton from './ShareButton';

const ShareButtons = () => {
	const { buttonsContainerClass, social } = useShare();

	return (
		<div
			className={`shareButtons vtex-store-components-3-x-shareButtons ${
				buttonsContainerClass ? buttonsContainerClass : 'flex flex-row'
			}`}
		>
			{social?.Facebook && <ShareButton social={'Facebook'} />}
			{social?.Twitter && <ShareButton social={'Twitter'} />}
			{social?.Pinterest && <ShareButton social={'Pinterest'} />}
			{social?.WhatsApp && <ShareButton social={'WhatsApp'} />}
		</div>
	);
};

export default ShareButtons;
